import { render } from "./TarjetasTratamientosGeneral.vue?vue&type=template&id=1f4ff46d&scoped=true"
import script from "./TarjetasTratamientosGeneral.vue?vue&type=script&lang=js"
export * from "./TarjetasTratamientosGeneral.vue?vue&type=script&lang=js"

import "./TarjetasTratamientosGeneral.vue?vue&type=style&index=0&id=1f4ff46d&lang=scss&scoped=true"

import exportComponent from "/home/rdimicheleb/Repos/AMII/apps/app-paciente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f4ff46d"]])

export default __exports__